<template>
  <el-card>
    <div ref="chartdiv" style="height: 500px" />
  </el-card>
</template>

<script lang="ts">
import useResize from '@/hooks/useResize'

import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  ref,
  watch,
  shallowRef
} from 'vue'

import { am4core, am4charts } from '@/utils/async_chart_loader'
import createAxisAndSeries from '@/utils/charts'
import { IAxe } from '@/api/types'

export default defineComponent({
  name: 'ReportGraph',
  props: {
    data: {
      type: Array,
      required: true
    },
    axes: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const { isDesktop } = useResize()
    const chartdiv = ref(null)
    const chartBox = shallowRef()

    const renderChart = () => {
      if (props.data.length < 1) {
        return
      }
      clearChart()
      // @ts-ignore: Object is possibly 'null'.
      const chart = am4core.create(chartdiv.value, am4charts.XYChart)
      chart.legend = new am4charts.Legend()
      chart.cursor = new am4charts.XYCursor()
      chart.responsive.enabled = true

      chart.colors.list = [
        am4core.color('#7d7d7d'), // gray
        am4core.color('#1890FF'), // blue
        am4core.color('#ff0000'), // red
        am4core.color('#52c41a'), // green
        am4core.color('#faad14') // orange
      ]

      // Add data
      chart.data = props.data

      // Create axes
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis())
      dateAxis.renderer.minGridDistance = 50

      const axes = props.axes as IAxe[]
      axes.forEach((axe: IAxe) => {
        createAxisAndSeries(
          chart,
          axe.value,
          'name',
          axe.title,
          false,
          'circle',
          false
        )
      })
      chartBox.value = chart
    }

    const clearChart = () => {
      if (chartBox.value && !chartBox.value.isDisposed) {
        chartBox.value.dispose()
        chartBox.value = null
      }
    }

    onMounted(() => {
      renderChart()
    })

    onBeforeUnmount(() => {
      clearChart()
    })

    watch(
      (_: any) => props.data,
      (_: any) => renderChart()
    )

    return { isDesktop, chartdiv }
  }
})
</script>

<style lang="scss" scoped>
.el-card {
  padding: 0;
  margin-top: 10px;
}
:deep(svg) {
  font-size: 0.8em;
}
</style>
